import { createSelector } from '@ngrx/store';
import { currentLocationState } from '../root';

export const getCurrentPickupTime = createSelector(currentLocationState, (currentLocation) => currentLocation.pickupTime);
